import { StatisticsManagementRouteMap } from '@/new-router/statistics-management'

const Home = () => import('@/views/Home/home')

const Calculcation = () => import('@/views/Calculcation/capacity')
const UserData = () => import('@/views/user-data')
const UserSubmitAnalysisList = () => import('../views/user-submit-analysis/user-submit-analysis.vue')
const PerformData = () => import('@/views/perform')
const JobData = () => import('@/views/job-data/job-data')
const RenderData = () => import('@/views/render-data')
const NewUserData = () => import('@/views/new-user-data')
const HardwareData = () => import('@/views/hardware-data')

/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export default [
  {
    path: '/data',
    name: 'data',
    component: Home,
    meta: {
      title: '数据',
      icon: 'icon-configuration',
      showSubiems: false,
      sort: 3,
      modules: 'calculcation',
      permission: 'stat',
    },
    children: [
      {
        path: 'capacity',
        name: 'capacity-management',
        component: Calculcation,
        meta: {
          title: '产能数据',
          active: ['capacity-management'],
          permission: 'node:stat',
          belong: ['statistics-management', 'capacity-management'],
        },
      },
      {
        path: 'perform',
        name: 'perform-data',
        component: PerformData,
        meta: {
          title: '性能数据',
          active: ['perform-data'],
          permission: 'performance:stat',
          belong: ['statistics-management', 'perform-data'],
        },
      },
      {
        path: 'user-data',
        name: 'user-data',
        component: UserData,
        meta: {
          title: '新用户作业渲染数据',
          active: ['user-data'],
          permission: 'user:stat',
          belong: ['statistics-management', StatisticsManagementRouteMap.UserData],
        },
      },
      {
        path: 'user-submit-analysis',
        name: 'user-submit-analysis',
        component: UserSubmitAnalysisList,
        meta: {
          title: '新用户提交分析数据',
          active: ['user-submit-analysis'],
          permission: 'user:first:submit:stat',
          belong: ['statistics-management', StatisticsManagementRouteMap.UserSubmitAnalysis],
        },
      },
      {
        path: 'job-data',
        name: 'job-data',
        component: JobData,
        meta: {
          title: '作业数据',
          active: ['job-data'],
          permission: 'task:stat',
          belong: ['statistics-management', 'job-data'],
        },
      },
      {
        path: 'render-data',
        name: 'render-data',
        component: RenderData,
        meta: {
          title: '渲染数据',
          active: ['render-data'],
          permission: 'frame:stat',
          belong: ['statistics-management', 'render-data'],
        },
      },
      {
        path: 'new-user-data',
        name: 'new-user-data',
        component: NewUserData,
        meta: {
          title: '用户数据',
          active: ['new-user-data'],
          permission: 'user:info:stat',
          belong: ['statistics-management', StatisticsManagementRouteMap.NewUserData],
        },
      },
      {
        path: 'hardware-data',
        name: 'hardware-data',
        component: HardwareData,
        meta: {
          title: '硬件数据',
          active: ['hardware-data'],
          permission: 'hardware:stat',
          belong: ['statistics-management', StatisticsManagementRouteMap.HardwareData],
        },
      },
    ],
  },
]
